import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { CancelXIcon } from "../icons/CancelXIcon";
import * as Styled from "./CloseButton.styled";
// TODO: unify styles with OverlayPanelCloseButton, add size variants
export const CloseButton = forwardRef(({ ...props }, ref) => (_jsx(Styled.CloseButton, { "data-testid": "CloseButton", icon: _jsx(CancelXIcon, { "aria-hidden": true }), ref: ref, ...props })));
CloseButton.displayName = "CloseButton";
